module.exports = "a {\n    font-size: 16px;\n}"